import { useEffect } from 'react';
import { RefinLeadBanner } from 'shared/components/RefinLeadBanner/';
import { landingApi } from 'shared/api/landingApi';
import { ERuntimeSettings } from 'shared/types/runtimeSettings';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { ILead } from 'shared/components/RefinLeadBanner/types';
import { selectCalculatorValues } from 'shared/selectors/landing';
import { useSelector } from 'react-redux';
import {
  mapCalculatorValuesToSaveLeadRequest,
  mapLeadToAttachMortgageRequest,
} from 'shared/utils/mappers/calculatorToSaveLeadMapper';
import { UiKitToastsContextProvider } from '@cian/ui-kit';
import { useLocalStorage } from 'shared/hooks/useLocalStorage/useLocalStorage';

const IS_REFIN_BANNER_FILLED_KEY = 'is_refin_banner_filled';

export const RefinBannerContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const { value: isRefinBannerFilled, setValue: setIsRefinBannerFilled } = useLocalStorage(
    IS_REFIN_BANNER_FILLED_KEY,
    'false',
  );
  const enabled = config.get<boolean>(ERuntimeSettings.refinBannerEnabled);
  const calculatorValues = useSelector(selectCalculatorValues);
  const [
    sendLead,
    { isLoading: isLeadSending, isSuccess: isLeadSuccessfullySent, data: leadResponse, isError: isLeadError },
  ] = landingApi.useSendLeadMutation();

  const [
    sendRefinLead,
    { isLoading: isRefinLeadSending, isSuccess: isRefinLeadSuccessfullySent, isError: isRefinLeadError },
  ] = landingApi.useSendRefinLeadMutation();

  const isLeadSentBefore = isRefinBannerFilled === 'true' && !(isRefinLeadSuccessfullySent || isLeadSuccessfullySent);

  // Mark banner as filled when refin lead is successfully sent
  useEffect(() => {
    if (isRefinLeadSuccessfullySent) {
      setIsRefinBannerFilled('true');
    }
  }, [isRefinLeadSuccessfullySent, setIsRefinBannerFilled]);

  if (!enabled || isLeadSentBefore) {
    return null;
  }

  const onSendLead = (phone: string) => {
    const saveLeadRequest = mapCalculatorValuesToSaveLeadRequest(calculatorValues, phone);
    sendLead(saveLeadRequest);
  };

  const onSendRefinLead = (lead: ILead) => {
    // TODO: Вот тут нужно передать id в данный запрос чтобы связать лиды
    if (leadResponse?.id) {
      const attachMortgageRequest = mapLeadToAttachMortgageRequest(lead, leadResponse.id);
      sendRefinLead(attachMortgageRequest);
    }
  };

  return (
    <UiKitToastsContextProvider>
      <RefinLeadBanner
        sendLead={onSendLead}
        isLeadSending={isLeadSending}
        isLeadSuccessfullySent={isLeadSuccessfullySent}
        sendRefinLead={onSendRefinLead}
        isRefinLeadSending={isRefinLeadSending}
        isRefinLeadSuccessfullySent={isRefinLeadSuccessfullySent}
        isLeadError={isLeadError}
        isRefinLeadError={isRefinLeadError}
      />
    </UiKitToastsContextProvider>
  );
};
